import { CircleIcon, Stack, Typography } from '@cmg/design-system';
import React from 'react';

import { AttestationFormStatus } from '../../../graphql';
import { AttestationFormStatusDisplayName, getAttestationStatusColor } from './Attestation.model';

export type Props = {
  status: AttestationFormStatus;
};

const AttestationFormStatusRenderer: React.FC<Props> = ({ status }) => {
  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography fontSize="small" display="flex" alignItems="center">
        <CircleIcon fontSize="inherit" color={getAttestationStatusColor(status)} />
      </Typography>
      <Typography>{AttestationFormStatusDisplayName[status]}</Typography>
    </Stack>
  );
};

export default AttestationFormStatusRenderer;
